export default "__VITE_ASSET__65b139f7__"